import { ComparisonRangeValue, DateRangeValue } from '../types';

export const COMPARISON_RANGES: { [key: string]: ComparisonRangeValue } = {
  PREVIOUS_PERIOD: 'previousPeriod',
  SAME_PERIOD_LAST_YEAR: 'samePeriodLastYear',
  CUSTOM: 'customPeriod',
  LAST_MONTH: 'lastMonth',
};

export const RANGES: { [key: string]: DateRangeValue } = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK_SUNDAY: 'thisWeekSunday',
  THIS_WEEK_MONDAY: 'thisWeekMonday',
  LAST_SEVEN_DAYS: 'lastSevenDays',
  LAST_WEEK_SUNDAY: 'lastWeekSunday',
  LAST_WEEK_MONDAY: 'lastWeekMonday',
  LAST_FOURTEEN_DAYS: 'lastFourteenDays',
  LAST_THIRTY_DAYS: 'last30Days',
  THIS_MONTH: 'thisMonth',
  LAST_MONTH: 'lastMonth',
  LAST_THREE_MONTHS: 'last3Months',
  LAST_SIX_MONTHS: 'last6Months',
  TWELVE_MONTHS_TO_DATE: 'twelveMonthsToDate',
  THIS_YEAR: 'thisYear',
  LAST_YEAR: 'lastYear',
  ALL_TIME: 'allTime',
  ALL_TIME_FIVE_YEARS: 'allTimeFiveYears',
  CUSTOM: 'custom',
  CUSTOM_TIME: 'customTime',
};
